<template>
  <div
    class="pic-resources-wrap trend-pic-wrap">
    <div class="pic-title">
      <i class="icon_resources" />
      更多潮图
    </div>


    <PicList
      :isShowPicTitle="true"
      class="PicList"
      :pic-list="trendPics"
    />


    <div class="pic-content _hide">
      <div
        v-for="(vo,idx) in trendPics"
        :key="vo.id"
        class="pic-item">
        <NavigationTo :path="MATERIAL_DETAIL + '/'+ vo.uniq_id + '.html'">
          <div slot="content">
            <img
              :src="IMG_BASE_URL + vo.proto_pic + '!/fw/279/quality/90/unsharp/true/compress/true'"
              class="pic-img">
          </div>
        </NavigationTo>

        <i v-if="vo.package == 1" class="icon_badge"/>
        <div v-if="vo.package != 1" class="legal-copy">正版</div>
        <NavigationTo :path="MEMBER_LICENSE_VIP" v-if="vo.package != 1">
          <div
            slot="content"
            class="_pointer legal-copy legal-copy-active">
            商用授权<i class="iconfont icon-a-arrowright"/>
          </div>
        </NavigationTo>

        <!-- 收藏 -->
        <div
          :class="[vo.isCollect === true ? 'on':'no']"
          class="collect _pointer"
          @click="toggleCollect(vo,idx)"
        >
          <i class="iconfont icon-collect"/>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import {IMG_BASE_URL, MATERIAL_DETAIL, MEMBER_LICENSE_VIP} from "~/constant/PATH";
import {fnLogin} from "@/fn";
import {toggleMaterialCollect} from "@/api/material";
import _ from 'lodash'
import PicList from '@/components/pic/pic-list/pic-list';


export default {
  name: "TuPianDetailsTrendPics",
  props: {
    trendPics: {
      type: Array | Object,
      default: () => []
    }
  },
  data() {
    return {
      MATERIAL_DETAIL,
      IMG_BASE_URL,
      MEMBER_LICENSE_VIP
    }
  },
  components: {
    PicList
  },
  methods: {
    toggleCollect: _.throttle(function (vo, idx) {

      if (fnLogin.checkLogin()) {
        let isCollect = vo.isCollect || false
        const {uniq_id} = vo;
        let act = isCollect === false ? 'collect' : 'remove';
        toggleMaterialCollect({
          uniq_id,
          act
        }).then(res => {
          let msg = isCollect === false ? '收藏成功' : '已取消收藏';
          vo.isCollect = isCollect === false ? true : false;
          this.$set(this.trendPics, idx, vo)
          this.$myNotify.success(msg);
        })
      } else {
        fnLogin.loginIntercept(false)
      }


    }, 2000),
  }
}
</script>

<style lang="scss" scoped>
@import "../common/pic-list";
.trend-pic-wrap{
  //margin-top: 40px;
}

.icon_badge {
  @include BgImage(71px, 68px, 'pic-package/icon_badge.svg');
  @include Position(1, 5, 0, 0);
  z-index: 3;
}

.pic-title{
  display: flex;
  align-items: center;
  .icon_resources{
    @include BgImage(32px,32px,'/tupian/detail/faxian.svg');
    margin-right: 16px;
  }
}




</style>
